import script from "./roadshowstudio.vue?vue&type=script&setup=true&lang=js"
export * from "./roadshowstudio.vue?vue&type=script&setup=true&lang=js"

import "./roadshowstudio.vue?vue&type=style&index=0&id=8f49aee4&scoped=scoped&lang=css"

import exportComponent from "K:\\宫俊勇\\青桔pc官网wf-qjgw\\wf-qjgw\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8f49aee4"]])

export default __exports__